import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Prose from "../utility/prose";

const TaxRate = () => {
    const data = useStaticQuery(graphql`
        query {
            allStrapiTaxRate (sort: {fields: year, order: DESC}) {
                nodes {
                    id
                    year
                    maintenance_operations_rate
                    debt_service_rate
                    contract_rate
                    road_rate
                    order_levying_taxes {
                        localFile {
                            publicURL
                        }
                    }
                }
            }
        }
  `)

    return (
        <Prose>
        <table className="w-full md:w-5/6 lg:w-2/3">
            <thead>
                <tr>
                    <td>Year</td>
                    <td>Debt Service</td>
                    <td>Maintenance</td>
                    <td>Contract</td>
                    <td>Total Tax Rate</td>
                    <td>Order Levying Taxes</td>
                </tr>
            </thead>
            <tbody>
                {data.allStrapiTaxRate.nodes.map(rate => (
                    <tr key={rate.id}>
                        <td>{rate.year}</td>
                        <td>$ {(rate.debt_service_rate).toFixed(4)}</td>
                        <td>$ {(rate.maintenance_operations_rate).toFixed(4)}</td>
                        <td>$ {(rate.contract_rate).toFixed(4)}</td>
                        <td>$ {(rate.debt_service_rate+rate.maintenance_operations_rate+rate.contract_rate).toFixed(4)}</td>
                        { rate.orderLevyingTaxes === null ? (<td></td>) : (<td className="not-prose"><a className="inline-block bg-neutral-200 hover:bg-neutral-300 dark:bg-neutral-800 hover:dark:bg-neutral-900 px-4 py-2 rounded-full leading-none" target="_blank" rel="noreferrer noopener" href={rate.order_levying_taxes.localFile.publicURL}>Order Levying Taxes – {rate.year}</a></td>)}
                    </tr>
                ))}
            </tbody>
        </table>
        </Prose>
    )
}

export default TaxRate